export default __webpack_public_path__ + "static/katerina-53df5ef1f9c199cb24f03c9f521dfb21.jpg";